import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2023 Krishav Enterprise. All rights reserved.</p>
    </footer>
  );
};

export default Footer;